import React from 'react'
import {Link} from 'gatsby'

export default props => {
	const style = props.style || {}
	const title = <p>{props.title}</p> || ''
	const subTitle = props.subTitle || null
	const iconBefore = props.iconBefore || ''
	const iconAfter = props.iconAfter || ''
	const id = props.id || ''
	const handleClick = props.handleClick || null
	const href = props.href || null
	let content = href 
		? <Link to={href} style={{color: 'inherit', display: 'inherit', alignItems: 'center', textDecoration: 'none'}}>
			{iconBefore}{title}{iconAfter}
		</Link>
		: <React.Fragment>{iconBefore}{title}
			{
				subTitle !== null && (
					<span><p>{subTitle}</p></span>
				)
			}
			{iconAfter}
			</React.Fragment>

	return (
		<div
			id={id}
			className='button'
			style={style}
			onClick={handleClick}
		>
			{content}
		</div>
	)
}